(() => {
  // The inline bootstrap has already denied optional cookies before app scripts.
  let previous = 'false:false:false';
  let loading = false;

  function allowed(method) {
    try {
      return window.Shopify?.customerPrivacy?.[method]?.() === true;
    } catch {
      return false;
    }
  }

  function sync() {
    // Allowed methods include Shopify's regional settings and persisted choice.
    const consent = {
      analytics: allowed('analyticsProcessingAllowed'),
      advertisement: allowed('marketingAllowed'),
      functionality: allowed('preferencesProcessingAllowed'),
    };
    const key = `${consent.analytics}:${consent.advertisement}:${consent.functionality}`;
    if (key === previous) return;
    window._hsp = window._hsp || [];
    window._hsp.push(['setHubSpotConsent', consent]);
    previous = key;
  }

  function initialize() {
    sync();
    const shopify = window.Shopify;
    if (['analyticsProcessingAllowed', 'marketingAllowed', 'preferencesProcessingAllowed']
      .every((method) => typeof shopify?.customerPrivacy?.[method] === 'function')) return;
    if (loading || typeof shopify?.loadFeatures !== 'function') return;
    loading = true;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        loading = false;
        if (!error) sync();
      });
    } catch {
      loading = false;
      // An unavailable native API leaves the early denial in effect.
    }
  }

  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', initialize);
  window.addEventListener('load', initialize, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  }
  initialize();
})();
